export default __webpack_public_path__ + "static/media/loading.04359305.gif";